






















import { defineComponent, watch, computed } from '@vue/composition-api';
import EditingFields from '@/components/molecules/EditingFields.vue';
import { useFormValidation } from '@/composables/use-form-validation';
import { useI18n } from '@/plugins/i18n/i18n';
import { editingCardModule } from '@/store/modules/EditingCardStore';
import { loginUserModule } from '@/store/modules/LoginUserStore';

export type Props = {
  title: string;
};

export default defineComponent({
  components: { EditingFields },
  props: {
    title: { type: String, required: true },
  },

  setup(_, { emit }) {
    const {
      valid,
      form,
      formValidate,
      resetFormValidation,
    } = useFormValidation();

    const language = computed(() => loginUserModule.userInfo.language);

    const editedItem = computed({
      get: () => editingCardModule.editedItem,
      set: (item: typeof editingCardModule.editedItem) =>
        editingCardModule.updateItem(item),
    });

    watch(() => editingCardModule.dialog, resetFormValidation);

    watch(
      () => editingCardModule.editedItem,
      newItem => {
        // Call formValidate when editedItem is changed for cross-validation of start date and end date.
        // If there is an empty input, an extra error message will be displayed and it will not be called.
        if (editingCardModule.name === 'announcement') {
          const emptyInput = editingCardModule.fields.find(
            field =>
              newItem[field.value] === null || newItem[field.value] === ''
          );
          if (
            !emptyInput ||
            editingCardModule.editedItem.displayStartDate <=
              editingCardModule.editedItem.displayEndDate
          ) {
            formValidate();
          }
        }
      },
      { deep: true }
    );

    const save = () => formValidate() && emit('save');
    const cancel = () => emit('cancel');

    return {
      cancelButtonName: useI18n('common.cancel'),
      saveButtonName: useI18n('common.save'),
      save,
      cancel,
      valid,
      form,
      language,
    };
  },
});
